module.exports = __webpack_public_path__ + "img/icon-home.6c31fb82.svg";